import { Injectable } from '@angular/core';
import { SubLevelDto } from '../model/subLevelDto';
import { ApiClientService } from './util/api.client.service';

@Injectable()
export class SubLevelService {
  constructor(private http: ApiClientService) { }

  getSubLevelByLevel(isEpda?: boolean) {
    return this.http.apiGet<SubLevelDto[]>('/subLevel', { params: { isEpda } });
  }

}



// WEBPACK FOOTER //
// D:/Projects/GitHub/education-ee-web/src/app/services/sub-level.service.ts